import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SearchForm from 'components/SearchForm';
import LanguageSelector from 'components/LanguageSelector';

import './SupportingMenu.scss';

const SubMenuLink = ({link, linkText}) => {
    if(!linkText) return null;

    return (
        <li>
            <a
                className="submenu-link"
                href={link}
            >{linkText}</a>
        </li>
    );
};

SubMenuLink.propTypes = {
    link: PropTypes.string,
    linkText: PropTypes.string,
};

const SupportingMenu = ({
    menu,
    searchLink,
    searchLabel,
    languages,
    onClick,
    isActive,
    isActiveOnMobile,
    inputPlaceholder,
    withCustomLogo,
    openQuickSearchFormBtnAriaLabel,
    closeQuickSearchFormBtnAriaLabel
}) => {
    const handleClickLanguage = function() {
        onClick('language');
    };

    const handleClickSearch = function() {
        var searchResultsForm = document && document.getElementById('search-results-form');
        if (searchResultsForm === null){
            onClick('search', () => {
                document && document.getElementById('global-menu-search').focus();
            });
        }
        else {
            searchResultsForm.focus();
        }
    };

    const classNames = classnames('submenu', {
        'open': isActiveOnMobile,
    });

    return (
        <nav className={classNames} role='navigation'>
            <ul className={classnames('top-header-secondary-menu', {
                'with-custom-logo': withCustomLogo
            })}>
                {menu && menu.map((l, i) => {
                    return <SubMenuLink key={i} {...l} />;
                })}
                <li className='divider'></li>
                <li onClick={handleClickLanguage}><LanguageSelector languages={languages} isActive={isActive} /></li>
                <li className='search' onClick={handleClickSearch}>
                    <SearchForm
                        inputPlaceholder={inputPlaceholder}
                        isActive={isActive}
                        searchLabel={searchLabel}
                        searchLink={searchLink}
                        openQuickSearchFormBtnAriaLabel={openQuickSearchFormBtnAriaLabel}
                        closeQuickSearchFormBtnAriaLabel={closeQuickSearchFormBtnAriaLabel}
                        withCustomLogo={withCustomLogo}
                    />
                </li>
            </ul>
        </nav>
    );
};

SupportingMenu.propTypes = {
    menu: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string,
        linkText: PropTypes.string,
    })),
    searchLink: PropTypes.string.isRequired,
    searchLabel: PropTypes.string.isRequired,
    languages: PropTypes.array,
    onClick: PropTypes.func,
    isActive: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    isActiveOnMobile: PropTypes.bool,
    inputPlaceholder: PropTypes.string,
    openQuickSearchFormBtnAriaLabel: PropTypes.string,
    closeQuickSearchFormBtnAriaLabel: PropTypes.string,
    withCustomLogo: PropTypes.bool
};

export default SupportingMenu;



// WEBPACK FOOTER //
// ./src/components/SupportingMenu/SupportingMenu.jsx